import useStyles from 'isomorphic-style-loader/useStyles';

import { getPrimaryCvss } from '@components/severity';
import { VulnerabilityIndicators } from '@components/vulnerability-indicators';

import { CommandPaletteOption } from '../command-palette/command-palette-option';
import { getPrimaryDetail } from '../quick-search.utils';

import type { VulnerabilityLookupItem } from './vulnerability-search.models';
import { vulnerabilitySearchOutcome } from './vulnerability-search.utils';
import s from './vulnerability-search-result-item.scss';

export interface VulnerabilitySearchResultItemProps {
  active: boolean;
  id: string;
  onActivate: () => void;
  onSelect: () => void;
  vulnerability: VulnerabilityLookupItem;
}

/**
 * A single advisory-result row: a CVE id with its indicator cluster and a
 * clamped description, linking to that CVE's detail page.
 */
export const VulnerabilitySearchResultItem = ({
  active,
  id,
  onActivate,
  onSelect,
  vulnerability,
}: VulnerabilitySearchResultItemProps) => {
  useStyles(s);

  const { vulnerabilityId } = vulnerability;
  const detail = getPrimaryDetail(vulnerability);

  return (
    <CommandPaletteOption
      active={active}
      id={id}
      onActivate={onActivate}
      onSelect={onSelect}
      outcome={vulnerabilitySearchOutcome(vulnerabilityId)}
    >
      <div className={s.heading}>
        <span className={s.cve}>{vulnerabilityId}</span>

        <VulnerabilityIndicators
          className={s.indicators}
          cvssAssessment={getPrimaryCvss(detail?.cvssAssessments)}
          epssPercentile={detail?.epssPercentile ?? null}
          epssScore={detail?.epssScore ?? null}
          kev={!!detail?.kev}
          vulnerabilityId={vulnerabilityId}
        />
      </div>

      <div className={s.description}>
        <span className={s.descriptionLabel}>Description</span>
        <span className={s.descriptionText}>{detail?.description}</span>
      </div>
    </CommandPaletteOption>
  );
};

export default VulnerabilitySearchResultItem;
